
import VLazyImage from 'v-lazy-image'

export default {
  name: 'SectionProcess',

  components: {
    VLazyImage,
  },
}
